import React, { useEffect } from "react";
import {
  IAnalyticsPaymentListFilterModel,
  IAnalyticsPaymentModel,
} from "@xala/common-services";
import {
  ITableCurrentDataSource,
  ITableFilter,
  ITablePaginationConfig,
  PageContent,
  Pagination,
  Table,
} from "@xala/common-ui";
import { usePaymentListColumns, usePaymentListDataProvider } from "../../hooks";
import { PaymentListHeader } from "./PaymentListHeader";

export const PaymentList = () => {
  const {
    dataLoader,
    filters,
    pagination,
    fullTextSearch,
    setFullTextSearch,
  } = usePaymentListDataProvider();

  const columns = usePaymentListColumns(filters);

  const handleTableChange = (
    _: ITablePaginationConfig,
    tableFilters: ITableFilter,
    sorter: any,
    __: ITableCurrentDataSource<any>
  ) => {
    const newFilters: IAnalyticsPaymentListFilterModel = {
      PaymentStatuses: (tableFilters.PaymentStatuses || []) as string[],
      PaymentTypes: (tableFilters.PaymentTypes || []) as string[],
    };
    switch (sorter.field) {
      case "PaymentDate":
        newFilters.SortAscending = sorter.order === "ascend";
        break;
      default:
    }

    filters.update((oldFilters) => ({
      ...oldFilters,
      ...newFilters,
    }));
  };

  useEffect(() => {
    filters.clear();
  }, []);

  return (
    <PageContent footer={<Pagination {...pagination.props} />}>
      <PaymentListHeader
        onRefresh={dataLoader.refresh}
        fullTextSearch={fullTextSearch}
        setFullTextSearch={setFullTextSearch}
        filters={filters}
      />

      <Table<IAnalyticsPaymentModel>
        rowKey={(row) => row.PaymentKey}
        columns={columns}
        dataSource={dataLoader.data?.Entities}
        loading={dataLoader.loading}
        pagination={false}
        sortDirections={["descend", "ascend"]}
        onChange={handleTableChange}
      />
    </PageContent>
  );
};
